import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { clientRoutes } from "_api/client-routes";
import { chatToken, endAttendance, findAttendance, npsAttendance } from "_api/fetchers/Client/attendances";
import { apiSwr } from '_api/swr';
import { Attendance } from '_types/models/Attendance';
import { EndAttendance, NpsAttendance } from '_types/requests/Client/attendance';
import { toastRequestError } from '_utils/axios';

export function useAttendance(id: string) {
    const queryKey = [...clientRoutes.attendance(id).show] as const;

    const swr = useSuspenseQuery({
        queryKey,
        queryFn: findAttendance,
    });
    const attendance = swr.data;

    return { ...swr, attendance } as const;
}


export function useAttendanceNoSuspense(id?: string ) {
    const queryKey = [...clientRoutes.attendance(id!).show] as const;

    const swr = useQuery({
        queryKey,
        queryFn: findAttendance,
        enabled: !!id,
    });
    const attendance = swr.data;

    return { ...swr, attendance } as const;
}


export function useAttendanceEnd(id: Attendance['id']) {
    const mutationKey = [...clientRoutes.attendance(id).end] as const;
    return useMutation({
        mutationKey,
        mutationFn: async (payload: EndAttendance) => {
            return endAttendance(mutationKey, payload);
        },

        onMutate: async d => {
            apiSwr.cancelQueries({ queryKey: [...clientRoutes.attendance(id).show] });
        },
        onSuccess: async d => {
            apiSwr.invalidateQueries({ queryKey: [...clientRoutes.attendance(id).show] });
        },
        onError: err => {
            toastRequestError(err);
        },
    });
}

export function useAttendanceSituationAndNps(id: Attendance['id']) {
    const mutationKey = [...clientRoutes.attendance(id).nps] as const;
    return useMutation({
        mutationKey,
        mutationFn: async (payload: NpsAttendance) => {
            return npsAttendance(mutationKey, payload);
        },

        onMutate: async d => {

        },
        onSuccess: async d => {

        },
        onError: err => {
            toastRequestError(err);
        },
    });
}

export function useAttendanceChatToken(id: Attendance['id']) {
    const mutationKey = [...clientRoutes.attendance(id).chatToken] as const;
    return useMutation({
        mutationKey,
        mutationFn: async () => {
            return chatToken(mutationKey);
        },

        onMutate: async d => {

        },
        onSuccess: async d => {

        },
        onError: err => {
            toastRequestError(err);
        },
    });
}
